export const COMPETITION_PICTURE_TYPE_IDS = {
  DreamCar: 1,
  LoyaltyClubComp: 2,
  Cash: 3,
  Lifestyle: 4,
  TieBreak: 101,
  DailyCompLegacy: 201,
  TimeLimited: 202,
  InstantWin: 301,
  Midweek: 5,
  Special: 6,
  EasyWin: 7,
  SmallLifestyle: 8,
  Daily: 203,
};

export const DEVICE_RESOLUTION = {
  Desktop: 1080,
  Laptop: 1024,
  Tablet: 768,
  Mobile: 240,
  MobileMin: 0,
};

export const CURRENCY_MAPPING: Record<string, string> = {
  "€": "EUR",
  "£": "GBP",
};
